/*
 * ls-elements
 * Copyright (C) 2024 Libriciel SCOP
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 */

import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ComponentRef,
  ViewChild,
  ViewContainerRef
} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {JsonPipe, NgComponentOutlet, NgSwitch, NgSwitchCase} from "@angular/common";
import {FieldsBaseComponent} from "../fields-base/fields-base.component";
import {FieldsRegistryService} from "../fields-registry.service";

@Component({
  selector: 'ls-field',
  standalone: true,
  imports: [
    NgSwitch,
    NgSwitchCase,
    FormsModule,
    FieldsBaseComponent,
    ReactiveFormsModule,
    NgComponentOutlet,
    JsonPipe
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './field.component.html',
  styleUrl: './field.component.scss',
})
export class FieldComponent extends FieldsBaseComponent<string> implements AfterViewInit  {
  @ViewChild('viewContainerRef', { read: ViewContainerRef }) vcr!: ViewContainerRef;
  ref!: ComponentRef<any>

  constructor(private fieldsRegistryService: FieldsRegistryService) {
    super();
  }

  ngAfterViewInit(): void {
    if(this.vcr) {
      this.ref = this.vcr.createComponent(this.fieldsRegistryService.getFieldComponent(this.question.type));
      this.ref.setInput('question', this.question);
      this.ref.setInput('form', this.form);
    }
  }
}
